import React from 'react';
import Card from '@mui/material/Card';
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import Text from '@directv-digital/fusion.atoms.text'
import { CheckIcon } from "@directv-digital/fusion.atoms.icons";
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

{ /* Generated by Copilot- Start */ }
interface CustomPlanCard {
  pkgName: string;
  price: string;
  channels: string;
  isSelected: boolean;
  key: any;
  onClick?: () => void;
  type?: string;
}
{ /* Generated by Copilot- End */ }

const CustomPlanCard = (props: CustomPlanCard) => {
  const { pkgName, price, channels, isSelected, key, type } = props;
  // Use a dark blue color similar to the image
  const cardBackgroundColor = isSelected ? colorPalette?.blue?.[900] : colorPalette?.neutral_white?.main;
  // Use a lighter color for the text
  const textColor = isSelected ? colorPalette?.neutral_white?.main : colorPalette?.blue?.[900];
  return (
      <Card
        aria-checked={isSelected}
        key={key}
        role="checkbox"
        tabIndex={0}
        sx={{
          width: type === 'multi' ? '237px' : '190px',
          height: '50px',
          '& svg': {
            width: '28px',
            height: '28px'
          },
          [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
            width: type === 'multi' ? '215px' : '175px',
            '& svg': {
              width: '24px',
              height: '24px'
            }
          },
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
             width: type === 'multi' ? '215px' : '155px',
            height: '45px',
            '& svg': {
              width: '20px',
              height: '20px'
            }
          },
          padding: 2,
          backgroundColor: cardBackgroundColor,
          color: textColor,
          border: '1px solid #8D8D8D',
          borderRadius: '8px',
          boxShadow: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          "&:hover": {
              backgroundColor: isSelected ? '#102641 !important' : '#10264114 !important'
          },
          "&:focus-visible": {
              outline: `4px solid transparent !important`,
              outlineColor: '#3885e1 !important',
              outlineOffset: '0px',
              backgroundColor: isSelected ? '#102641' : colorPalette?.neutral_white?.main

          }
        }}
        onClick={props?.onClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            props?.onClick?.();
          }
        }}
        aria-label={`${pkgName}${price ? `, ${price}` : ''}${channels ? `, ${channels}` : ''}`}
      >
        {/* Checkmark Icon */}
        {/* Generated by Copilot- Start */}
        {isSelected && (
          <CheckIcon fill={textColor} />
        )}
        {/* Generated by Copilot- End */}
        {/* Content Area */}
        <DtvBox sx={{
          width: '100%'
        }}>
          <Text variant="body1" sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
            {pkgName}
          </Text>
          <DtvBox sx={{
 display: 'flex',
justifyContent: 'space-between',
alignItems: 'center',
            width: '100%'
          }}>
            <Text variant="body1"  sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
              {price}
            </Text>
            <Text variant="body1" sx={{
                fontSize: '16px !important',
                [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                  fontSize: '14px !important'
                }
              }}>
              {channels}
            </Text>
          </DtvBox>
        </DtvBox>
      </Card>
  );
};

export default CustomPlanCard;
